import { render, staticRenderFns } from "./SystemSetting.vue?vue&type=template&id=8314642c&"
import script from "./SystemSetting.vue?vue&type=script&lang=ts&"
export * from "./SystemSetting.vue?vue&type=script&lang=ts&"
import style0 from "./SystemSetting.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SystemSetting.vue"
export default component.exports